import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'hooks'

export default function RootPage() {
  const { isReady, user } = useAuth()
  const history = useHistory()

  const currentOrg = user?.organizationUsers?.nodes?.[0]?.organization
  const companyId = currentOrg?.organizationCompanies?.nodes?.[0]?.company?.id
  const companyCount = currentOrg?.organizationCompanies?.totalCount
  let redirectPath

  if (currentOrg) {
    const orgPath = `orgs/${currentOrg.slug}`
    const companyPath = companyCount === 1 && companyId ? `companies/${companyId}` : 'companies'
    redirectPath = `/${orgPath}/${companyPath}`
  } else {
    redirectPath = '/auth/create-organization'
  }

  useEffect(() => {
    if (isReady) {
      if (user) {
        history.replace(redirectPath)
      } else {
        // not logged in, redirect to auth
        history.replace('/auth/login')
      }
    }
  }, [isReady, user, history, redirectPath])

  return null
}
